// Generated by CoffeeScript 2.7.0
var QueryParser, generateUrlWithParams, parseUrl;

({parseUrl, generateUrlWithParams} = Skylark.Helpers.UrlHelper);

QueryParser = class QueryParser {
  constructor() {
    this._reset();
  }

  parse(query = '') {
    this._reset();
    return _.each(query.split(/\s|\+/), (query_str) => {
      var base, name1, query_str_ary;
      query_str_ary = query_str.split(/:/);
      if (query_str_ary.length === 2) {
        if ((base = this.queries)[name1 = _.first(query_str_ary)] == null) {
          base[name1] = [];
        }
        return this.queries[_.first(query_str_ary)].push(_.last(query_str_ary));
      } else {
        return this.query_text += query_str + ' ';
      }
    });
  }

  _reset() {
    this.query_text = '';
    return this.queries = {};
  }

  toQuery(options = {}) {
    var filter_options, filtered_queries, queries_str, query_text;
    ({filter_options, query_text} = _.defaults({}, options, {
      filter_options: {},
      query_text: this.query_text
    }));
    filtered_queries = _.extend({}, this.queries, filter_options);
    queries_str = _.map(filtered_queries, function(values, name) {
      return _.map(values, function(v) {
        return `${name}:${v}`;
      }).join('+');
    }).join('+');
    if (_.isEmpty(query_text)) {
      return queries_str;
    } else {
      return `${query_text.trim()}+${queries_str}`;
    }
  }

};

export var AdvancedQueryInput = class AdvancedQueryInput {
  constructor(element, options1 = {}) {
    this.element = element;
    this.options = options1;
    this.input = this.element.find('input[type=text]');
    this.query_url = this.element.data('query_url');
    this.init();
  }

  init() {
    this.params = parseUrl(location.search).params;
    this.query_parser = new QueryParser();
    this.query_parser.parse(this.params.q);
    this._updateClass();
    this.element.node.proxy('click', '.js_clear_word', (event) => {
      return this.doQuery();
    });
    this.input.node.addEventListener('input', (event) => {
      return this.inputChanged(event);
    }, false);
    return this.input.node.addEventListener('keyup', (event) => {
      if (event.keyCode === 13) {
        this._updateClass();
        this.doQuery(event.target.value);
        return event.preventDefault();
      }
    }, false);
  }

  inputChanged(event) {
    return this._updateClass();
  }

  doQueryWithParams({keyword, filter_options}) {
    var params, query_params;
    query_params = {};
    if (keyword != null) {
      query_params['query_text'] = keyword;
    }
    if (filter_options != null) {
      query_params['filter_options'] = filter_options;
    }
    params = _.extend({}, this.params, {
      q: this.query_parser.toQuery(query_params)
    });
    return Turbolinks.visit(generateUrlWithParams(this.query_url, params));
  }

  doQuery(word = '') {
    var params;
    params = _.extend({}, this.params, {
      q: this.query_parser.toQuery({
        query_text: word
      })
    });
    return Turbolinks.visit(generateUrlWithParams(this.query_url, params));
  }

  _updateClass() {
    if (this.input.node.value) {
      return this.element.addClass('has-value');
    } else {
      return this.element.removeClass('has-value');
    }
  }

};

export var QueryInput = class QueryInput {
  constructor(element, options1 = {}) {
    this.element = element;
    this.options = options1;
    this.input = this.element.find('input[type=text]');
    this.init();
  }

  init() {
    this.query_url = this.element.data('query_url');
    this.params = parseUrl(location.search).params;
    if (_.isEmpty(_.keys(this.params))) {
      this.params = {
        status: 'published'
      };
    }
    this._updateClass();
    this.element.node.proxy('click', '.js_clear_word', (event) => {
      return this.cancelQuery();
    });
    this.input.node.addEventListener('input', (event) => {
      return this.inputChanged(event);
    }, false);
    return this.input.node.addEventListener('keyup', (event) => {
      if (event.keyCode === 13) {
        this._updateClass();
        this.doQueryWithWord(event.target.value);
        return event.preventDefault();
      }
    }, false);
  }

  inputChanged(event) {
    return this._updateClass();
  }

  doQueryWithWord(word) {
    var url;
    if (word) {
      url = generateUrlWithParams(this.query_url, _.extend(this.params, {
        q: word
      }));
      return Turbolinks.visit(url);
    } else {
      return this.cancelQuery();
    }
  }

  cancelQuery() {
    var params, url;
    params = parseUrl(location.search).params;
    delete params.q;
    url = generateUrlWithParams('/admin/messages', params);
    if (url === `${location.pathname}${location.search}`) {
      this.element.removeClass('has-value');
      this.input.node.value = '';
      return this.input.node.blur();
    } else {
      return Turbolinks.visit(url);
    }
  }

  _updateClass() {
    if (this.input.node.value) {
      return this.element.addClass('has-value');
    } else {
      return this.element.removeClass('has-value');
    }
  }

};

export var BasicQueryInput = class BasicQueryInput {
  constructor(element, options1 = {}) {
    this.element = element;
    this.options = options1;
    this.input = this.element.find('input[type=text]');
    this.query_url = this.element.data('query_url');
    this.options = _.pick(this.options, 'queryFunc', 'cancelQueryFunc');
    this.queryedStatus = !_.isEmpty(this.input.node.value);
    this.init();
  }

  init() {
    this._updateClass();
    this.element.node.proxy('click', '.js_clear_word', (event) => {
      return this.cancelQuery();
    });
    this.input.node.addEventListener('input', (event) => {
      return this._updateClass();
    }, false);
    return this.input.node.addEventListener('keyup', (event) => {
      if (event.keyCode === 13) {
        return this.doQueryWithWord(event.target.value);
      }
    }, false);
  }

  doQueryWithWord(word) {
    if (_.isEmpty(word)) {
      return this.cancelQuery();
    } else {
      return this.options.queryFunc(word);
    }
  }

  cancelQuery() {
    this.element.removeClass('has-value');
    this.input.node.value = '';
    _.defer(() => {
      return this.input.node.blur();
    });
    if (this.queryedStatus) {
      return this.options.cancelQueryFunc();
    }
  }

  _updateClass() {
    if (this.input.node.value) {
      return this.element.addClass('has-value');
    } else {
      return this.element.removeClass('has-value');
    }
  }

};
